// extracted by mini-css-extract-plugin
export default {"playLoader":"RecordPlayer_playLoader__oucjn"};